import { Row, Col, Modal, Typography } from "antd";
import { connect, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Feedback from "../Utilities/Feedback";
import { StyledButton } from "../styled-components/components";
import AddSkills from "./Skills/AddSkills";
import ListSkills from "./Skills/ListSkills";
import { fetchUserSkills, fetchAllSkills } from "../Redux/Consultant/reducer";
import { LoadingOutlined } from "@ant-design/icons";
import constants from "../Redux/constants";

const Skills = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const { userSkills } = useSelector((state) => state.consultantStore);
  const { fetchUserSkills, fetchAllSkills } = props;
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const getUserSkills = async () => {
      const responseStatus = await fetchUserSkills();
      if (responseStatus === constants.status.success) {
        setLoading(false);
      }
    };
    getUserSkills();
  }, [fetchUserSkills]);
  useEffect(() => {
    const getAllSkills = async () => {
      await fetchAllSkills();
    };
    getAllSkills();
  }, [fetchAllSkills]);
  return (
    <Col>
      {loading ? (
        <Col
          style={{
            background: "#ffffff",
            padding: "4vh",
          }}
        >
          <Feedback icon={<LoadingOutlined />} title="Fetching your skills" />
        </Col>
      ) : (
        <Col>
          {userSkills.length === 0 ? (
            <Col
              xl={{ span: 12 }}
              style={{
                background: "#ffffff",
                padding: "4vh",
              }}
            >
              <Row justify="center">
                <Typography.Title level={5}>Please Add Skills</Typography.Title>
              </Row>
              <Row justify="center">
                <StyledButton
                  onClick={openModal}
                  color="#16AAD9"
                  data-testid="submit-addSkill"
                >
                  Add Skills
                </StyledButton>
              </Row>
              <Modal
                visible={showModal}
                footer={null}
                closeIcon={null}
                closable={false}
                width="1050px"
              >
                <AddSkills closeModal={closeModal} />
              </Modal>
            </Col>
          ) : (
            <Col>
              <ListSkills />
            </Col>
          )}
        </Col>
      )}
    </Col>
  );
};

const mapStateToProps = (state) => ({
  userSkills: state.consultantStore.userSkills,
});

const mapToReducer = (dispatch) => {
  return {
    fetchUserSkills: () => dispatch(fetchUserSkills()),
    fetchAllSkills: () => dispatch(fetchAllSkills()),
  };
};

export default connect(mapStateToProps, mapToReducer)(Skills);
